<sq-modal [title]="'msg#label.filters'" [modal]="true">
    <app-filters [results]="data.results" [aggregations]="data.aggregations" [modal]="true"></app-filters>
</sq-modal>